import React from 'react';
import { CardsContainer, Container, Data, Heading, Logo, Wrapper } from './fraudPrevention.style';
import FraudPreventionCard from '../../components/FraudPreventionCard';
import Authenticate_Logo from '../../../../images/logos/authenticate_light.svg';
import PropTypes from 'prop-types';

const FraudPrevention = ({ heading, cardOne, cardTwo }) => {
    return (
        <Wrapper>
            <Container>
                <Data>
                    <Heading>
                        {heading} <Logo src={Authenticate_Logo} alt="Authenticate Logo" />
                    </Heading>
                    <CardsContainer>
                        <FraudPreventionCard data={cardOne} />
                        <FraudPreventionCard data={cardTwo} secondary />
                    </CardsContainer>
                </Data>
            </Container>
        </Wrapper>
    );
};

FraudPrevention.propTypes = {
    heading: PropTypes.string,
    cardOne: PropTypes.object,
    cardTwo: PropTypes.object,
};

export default FraudPrevention;
